import * as React from "react";
import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { isNodeOrChildrenContainsNotEmptyValue } from "../../viewModelUtils";
import { withResolvePaths } from "../../withResolvePaths";
import { ControlDependency, withRuntimeDependencies } from "../../withRuntimeDependencies";
import { withViewModelSelect } from "../../withViewModelSelect";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { setToModel } from "../../../Engine/ActionCreators/AllActionCreators";

import { Pencil } from "./Pencil";

export interface PencilContainerProps {
    dependencies?: ControlDependency[];
    viewModelSelect: ViewModelSelect;
    children: React.ReactNode;
}

const mapStateToProps = (state: FullFormState, ownProps: PencilContainerProps) => {
    const dependenciesFilled = (ownProps.dependencies ?? []).some(x =>
        isNodeOrChildrenContainsNotEmptyValue(ownProps.viewModelSelect.node(state, x.path))
    );
    const pencilOpened = (ownProps.dependencies ?? []).some(
        x => ownProps.viewModelSelect.pathViewModel(state, x.path).pencilOpened ?? false
    );
    return {
        opened: pencilOpened || dependenciesFilled,
        isReadOnly: state.settings.isReadOnly,
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: PencilContainerProps) => ({
    onOpenPencil: () => {
        for (const dependency of ownProps.dependencies ?? []) {
            dispatch(setToModel(dependency.path, "pencilOpened", true));
        }
    },
});

export const PencilContainer = withRuntimeDependencies(
    withResolvePaths(withViewModelSelect(connect(mapStateToProps, mapDispatchToProps)(Pencil)))
);
